


































import { Component, Vue } from "vue-property-decorator";

@Component
export default class OneKeyTip extends Vue {
    oneKeyTipVisible = false;
    oneKeyId: null | number = null;
    oneKeyType: "一键登录" | "勾选认证" = "一键登录";
    oneKeyStatus = {
        accountBookId: this.oneKeyId,
        bookName: "",
        lockTime: "",
        lockState: 0,
        nationalName: ""
    };

    async fetchLock() {
        if (this.oneKeyId !== null) {
            const res = await Vue.axios.get(`accountbooks/tax/prepare?accountBookId=${this.oneKeyId}`);
            this.oneKeyStatus = res.data.data;
        }
    }
    async oneKey(id: number, type: "一键登录" | "勾选认证" = "一键登录") {
        this.oneKeyId = id;
        await this.fetchLock();
        this.oneKeyTipVisible = true;
        this.oneKeyType = type;
    }
    oneKeyFn() {
        if (this.oneKeyId !== null) this.$utils.oneKeyFn(this.oneKeyId, this, this.oneKeyType);
    }

}
